export default __webpack_public_path__ + "static/media/no_image_potrait.7d52c76c.jpg";